export class EnrollMilitaryRegistration {
  towards_military_service: number = null;
  name_military_registration: string = '';
  military_registration_id_number: string = '';
  military_registration_id_date: Date;
  military_registration_id_scan: any;
}



// WEBPACK FOOTER //
// ./src/app/modules/enroll/components/model/enroll-military-registration.ts